import {css} from '@emotion/css';
import Modal from 'patient-ping-remedy/packages/modal';
import {SmallTypography} from 'patient-ping-remedy/packages/typography';
import Button, {StyleType} from 'patient-ping-remedy/packages/button';
import {layeredModal} from '@common/ConfirmAIUnassignModal.styles';

interface Props {
  close: () => void;
  unassignAIAgent: () => void;
}

export default function ConfirmAIUnassignModal({ close, unassignAIAgent }: Props) {
  const buttons = [
    <Button
      key="cancel"
      onClick={close}
      styleType={StyleType.TERTIARY}
    >
      Cancel
    </Button>,
    <Button
      key="unassign"
      onClick={unassignAIAgent}
    >
      Unassign
    </Button>
  ];

  return (
    <>
      <style>
        {layeredModal.styles}
      </style>
      <Modal
        className={css({ width: '70rem' })}
        headerText="Unassign AI Agent"
        hideModal={close}
        buttons={buttons}
      >
        <SmallTypography>
          Are you sure you want to unassign the AI Agent from this task?
        </SmallTypography>
      </Modal>
    </>
  );
}
